import { Injectable } from "@angular/core";
import { Observable, firstValueFrom } from "rxjs";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { AppConsts } from "../shared/app-consts";
import { BaseService } from "./base.service";
import * as _ from 'lodash';
import { HolidayTypeModel } from '../modules/holidays/models/holidayType.model';
import { HolidayModel, HolidayModelRequest } from '../modules/holidays/models/holiday.model';
import { HolidayRequestModel } from '../modules/holidays/models/holidayRequest.model';
import { HolidayFilterRequest } from '../modules/holidays/models/holidayFilterRequest.model';
import { serialize } from 'object-to-formdata';
import { HolidaySynthesisModel } from '../modules/holidays/models/holidaySynthesis.model';
import { HolidayCountByTypeModel } from '../modules/holidays/models/HolidayCountByType.model';

@Injectable({
  providedIn: 'root',
})
export class HolidayService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  getHoliday(holidayId: string): Observable<HolidayModel> {
    let httpOptions = this.getHttpHeader();

    httpOptions.params = _.assign({ holidayId: holidayId }, httpOptions.params);

    return this.http.get<HolidayModel>(AppConsts.API_SERVICE_URL + "holiday/GetById", httpOptions);
  }

  getAllHolidays(): Observable<HolidayModel[]> {
    return this.http.get(AppConsts.API_SERVICE_URL + 'holiday/all', this.getHttpHeader()) as Observable<HolidayModel[]>;
  }

  getAllHolidaySynthesis(): Observable<HolidaySynthesisModel[]> {
    return this.http.get(AppConsts.API_SERVICE_URL + 'holidaySynthesis/all', this.getHttpHeader()) as Observable<HolidaySynthesisModel[]>;
  }

  getHolidaysByUserId(request: HolidayFilterRequest): Observable<any> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));
    return this.http.get(AppConsts.API_SERVICE_URL + 'holiday/allByUserId', httpOptions);
  }

  checkValidity(request: HolidayFilterRequest): Observable<any> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));
    return this.http.get(AppConsts.API_SERVICE_URL + 'holiday/checkValidity', httpOptions);
  }



  getHolidaySynthesisByUserId(request: HolidayFilterRequest): Observable<any> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));
    return this.http.get(AppConsts.API_SERVICE_URL + 'holidaySynthesis/allByUserId', httpOptions);
  }
  getHolidaysCountByType(request: HolidayFilterRequest): Observable<HolidayCountByTypeModel[]> {

    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));
    return this.http.post(AppConsts.API_SERVICE_URL + "holiday/GetCountHolidaysBytype", request, httpOptions) as Observable<HolidayCountByTypeModel[]> ;
  }


  getHolidaySynthesisByFilterRequest(request: HolidayFilterRequest): Observable<any> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.get(AppConsts.API_SERVICE_URL + "holidaySynthesis/allByFilterRequest", httpOptions);
  }

  getAllHolidayTypes(): Observable<HolidayTypeModel[]> {
    return this.http.get(AppConsts.API_SERVICE_URL + 'holidayType/all', this.getHttpHeader()) as Observable<HolidayTypeModel[]>;
  }


  saveHoliday(request: HolidayModelRequest):Observable<number>{ 
   let options = {
    headers: new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "X-Requested-With": "XMLHttpRequest" 
  })};
    
  const formData = new FormData();
   formData.append("dto",JSON.stringify(request.HolidayModel));
  if(request.File)
    formData.append('file', request.File, request.FileName); 
    if (request.HolidayModel.Id != null)
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holiday/Edit", formData, options);
    else
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holiday/Add", formData, options);
  }

  saveHolidayFromPortage(request: HolidayModelRequest):Observable<number>{ 
   let options = {
    headers: new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "X-Requested-With": "XMLHttpRequest" 
  })};
    
  const formData = new FormData();
   formData.append("dto",JSON.stringify(request.HolidayModel));
  if(request.File)
    formData.append('file', request.File, request.FileName); 
    if (request.HolidayModel.Id != null)
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holiday/EditFromPortage", formData, options);
    else
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holiday/AddFromPortage", formData, options);
  }

  saveHolidaySynthesis(holidaySynthesis: HolidaySynthesisModel): Observable<number> {
    let httpOptions = this.getHttpHeader();

    if (holidaySynthesis.Id > 0)
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holidaySynthesis/Edit", holidaySynthesis, httpOptions);
    else
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holidaySynthesis/Add", holidaySynthesis, httpOptions);

  }

  validateHoliday(holidayRequest: HolidayRequestModel): Observable<number> {
      let httpOptions = this.getHttpHeader();
      return this.http.post<number>(AppConsts.API_SERVICE_URL + "holiday/validate", holidayRequest, httpOptions);

  }
  cancelHoliday(holiday: HolidayModel): Observable<HolidayModel> {
    let httpOptions = this.getHttpHeader();
    return this.http.post<HolidayModel>(AppConsts.API_SERVICE_URL + "holiday/cancel", holiday, httpOptions);
  }

  deleteHoliday(id: string): Observable<any> {
    const httpOptions = this.getHttpHeader();

    return this.http.post(AppConsts.API_SERVICE_URL + 'holiday/Delete', id, httpOptions) as Observable<any>;
  }

  getNumberOfDay(holiday: HolidayModel): Observable<number> {
  let httpOptions = this.getHttpHeader();
  return this.http.post<number>(AppConsts.API_SERVICE_URL + 'holiday/numberOfDay', holiday, httpOptions);
    
  }

  exportHolidayToExcel(request: HolidayFilterRequest) {

    let httpOptions = this.getHttpHeader(true);

    return firstValueFrom(this.http.post(AppConsts.API_SERVICE_URL + "holiday/exportHolidayToExcelAsAttachment", request, httpOptions))
      .then((response: any) => {
        return this.getFileFromResponse(response);
      });
  }
  exportHolidayByUserIdToExcel(request: HolidayFilterRequest) {

    let httpOptions = this.getHttpHeader(true);

    return firstValueFrom(this.http.post(AppConsts.API_SERVICE_URL + "holiday/exportHolidayByUserIdToExcelAsAttachment", request, httpOptions))
      .then((response: any) => {
        return this.getFileFromResponse(response);
      });
  }
  exportHolidaySynthesisByUserIdToExcel(request: HolidayFilterRequest) {

    let httpOptions = this.getHttpHeader(true);

    return firstValueFrom(this.http.post(AppConsts.API_SERVICE_URL + "holidaySynthesis/exportHolidaySynthesisByUserIdToExcelAsAttachment", request, httpOptions))
      .then((response: any) => {
        return this.getFileFromResponse(response);
      });
  }
  

}
